import React from 'react'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// i18n for legacy components
import { withTranslation } from 'react-i18next';

class AddPlayerForm extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            name: '',
            lastname: '',
            email: ''
        }

        // Bindings
        this.handleChange = this.handleChange.bind(this)

    }

    handleChange(e){
        const n = e.target.name;
        const v = e.target.value;
        let state = {...this.state};
        state[n] = v;
        this.setState(state, () => {
            this.props.onChange && this.props.onChange(state)
        });
    }

    render(){
        const { t } = this.props;

        return <div className="form-row mb-3">
                <div className="col mb-2">
                    <input name="name" className="form-control form-control-lg" value={ this.state.name } placeholder={t("Name")} onChange={ this.handleChange } />
                </div>
                <div className="col mb-2">
                    <input name="lastname" className="form-control form-control-lg" value={ this.state.lastname } placeholder={t("Surname")} onChange={ this.handleChange } />
                </div>
                <div className="col">
                    <input name="email" className="form-control form-control-lg" value={ this.state.email } placeholder="Email" onChange={ this.handleChange } />
                </div>
                {/* <div className="col-1">
                    <button className="btn btn-light btn-md">
                        <FontAwesomeIcon className="text-danger" icon="trash-alt" size="1x" style={{ cursor: 'pointer' }} />
                    </button>
                </div> */}
            </div>
    }

}

// i18n for legacy components
const AddPlayerFormWithTranslation = withTranslation()(AddPlayerForm);

export default AddPlayerFormWithTranslation

// Revisar I18n no tenga problemas.